import storage from "@/App/services/storage.service";
import userService from "@/Pages/Login/services/user.service";
import type { DashboardFilters } from "@/Pages/Cases/filtering/DashboardFilters";
import type { UserPreferences } from "@/App/user/User";
import { userHasFeatureEnabled } from "@/App/user/userHasFeatureEnabled";
import { FeatureFlag } from "@/App/types/FeatureFlag";
import { HttpClient } from "@/App/services/httpClient/HttpClient";
import {
  convertFiltersToRequestBody,
  convertFilterToRequestBody,
} from "@/Pages/Cases/filtering/convertFiltersToRequestBody";
import { parseDashboard1Filter } from "@/Pages/Cases/filtering/parseDashboard1Filter";
import type { UpdatePreferencesRequestBody } from "@/Pages/Cases/filtering/UpdatePreferencesRequestBody";
import type { DashboardFiltersInUser } from "@/Pages/Cases/filtering/DashboardFiltersInUser";
import UserService from "@/Pages/Login/services/user.service";

export const emptyDashboardFilters = (): DashboardFilters => ({
  complaints: [],
  hospitals: [],
  ems: [],
});

const filtersStorageKey = (): string => `${userService.getUserId()}_filters`;

export const filtersService = {
  saveFilters(filters: DashboardFilters): void {
    storage.save(filtersStorageKey(), filters);
  },

  getFilters(): DashboardFilters {
    const user = UserService.getUser();
    const defaultFilters = user?.preferences?.defaultDashboardFilter;
    if (defaultFilters && userHasFeatureEnabled({ user, feature: FeatureFlag.dashboard1FiltersOnDashboard2 })) {
      return parseDashboard1Filter(defaultFilters);
    }
    return storage.getItemAsObject(filtersStorageKey()) ?? emptyDashboardFilters();
  },

  saveFiltersOnServer(
    filters: DashboardFiltersInUser[],
    defaultFilter?: DashboardFiltersInUser | null,
  ): Promise<UserPreferences> {
    const dashboardFilters = convertFiltersToRequestBody(filters);
    const requestBody: UpdatePreferencesRequestBody = { preferences: { dashboardFilters } };
    if (defaultFilter !== undefined) {
      requestBody.preferences.defaultDashboardFilter = convertFilterToRequestBody(defaultFilter);
    }
    return HttpClient.put<UserPreferences>({ path: "/users", body: requestBody });
  },
  saveDefaultFilter(filter: DashboardFiltersInUser | null): Promise<UserPreferences> {
    const defaultDashboardFilter = convertFilterToRequestBody(filter);
    const requestBody: UpdatePreferencesRequestBody = { preferences: { defaultDashboardFilter } };
    return HttpClient.put<UserPreferences>({ path: "/users", body: requestBody });
  },
};
